function createDigitColumn(): HTMLElement {
  const col = document.createElement('span');
  col.className = 'infra-roll-digit';
  const strip = document.createElement('span');
  strip.className = 'infra-roll-digit-strip';
  for (let i = 0; i < 10; i++) {
    const num = document.createElement('span');
    num.className = 'infra-roll-digit-num';
    num.textContent = String(i);
    strip.appendChild(num);
  }
  col.appendChild(strip);
  return col;
}

export function bindRollCounter(host: HTMLElement): {
  set: (value: number, animate?: boolean) => void;
  get: () => number;
} {
  let current = -1;
  host.classList.add('infra-stat-value-roll-host');

  let counterEl = host.querySelector('.infra-roll-counter');
  if (!(counterEl instanceof HTMLElement)) {
    host.textContent = '';
    const created = document.createElement('span');
    created.className = 'infra-roll-counter';
    host.appendChild(created);
    counterEl = created;
  }

  const counter = counterEl;

  function set(value: number, animate = true): void {
    const next = Math.max(0, Math.round(value));
    const prev = current;
    current = next;
    const nextStr = String(next);
    const prevStr = prev < 0 ? nextStr : String(prev);

    while (counter.children.length < nextStr.length) {
      counter.appendChild(createDigitColumn());
    }
    while (counter.children.length > nextStr.length) {
      counter.lastChild?.remove();
    }

    const cols = Array.from(counter.children) as HTMLElement[];
    nextStr.split('').forEach((ch, i) => {
      const digit = Number(ch);
      const strip = cols[i]?.querySelector('.infra-roll-digit-strip');
      if (!(strip instanceof HTMLElement)) return;
      const prevDigit = prevStr.length > i ? Number(prevStr[i]) : digit;
      const shouldAnimate = animate && prev >= 0 && prevDigit !== digit;
      if (!shouldAnimate) {
        strip.classList.add('is-instant');
      } else {
        strip.classList.remove('is-instant');
      }
      strip.style.transform = `translateY(-${digit}em)`;
      if (!shouldAnimate) {
        requestAnimationFrame(() => strip.classList.remove('is-instant'));
      }
    });
  }

  return {
    set,
    get: () => current
  };
}
